'use client';
import { ArticleJsonLd } from 'next-seo';
import { SeoProps } from '@repo/ui/src/types/seo';
import { MediaType } from '@repo/ui/src/types/image';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import useCurrentUrl from '@repo/ui/src/hooks/useCurrentUrl';

export interface ArticleSeoProps {
  title: string;
  seoObj: SeoProps;
  headerAsset: Array<MediaType>;
}

const ArticleSeo = ({ title, seoObj, headerAsset }: ArticleSeoProps) => {
  const { path } = useCurrentUrl();
  const url = `${process.env.NEXT_PUBLIC_WEB_ENV}/${path}`;
  const imgUrl = buildImageSrc(headerAsset?.[0] ?? null, 500, 1, 1);

  return (
    <ArticleJsonLd
      useAppDir
      url={url}
      title={title}
      images={[imgUrl]}
      datePublished=""
      authorName="Traeger"
      publisherName="Traeger"
      description={seoObj?.ogDescription ?? ''}
    />
  );
};

export default ArticleSeo;
